module.exports = __webpack_public_path__ + "b74754268c43d115844f90c6ec20fde2.pdf";